import { Route } from 'src/routes/Route'

export const ActSuccessRoute = Route({
  path: '/success/:cardId',
  init: (cardId: string) => ({ cardId }),
  fromPath: ({ cardId }) => (cardId ? { cardId } : undefined),
})
export type ActSuccessRoute = Route<typeof ActSuccessRoute>
